import binarySearch from "./binarySearch";

/**
 * Returns handler for `property:position` event.
 * While real items not resolved, do nothing due to fake item match any position and emulating already exposed text.
 *
 * @param {SRTItem[]} items
 * @param {function(string): void} emit
 * @return {function({name: string, data: number}): void} position update handler,
 * use `emit` parameter for exposing subs text based for current position
 */
export default function SubEmitter(items, emit) {
  /**
   * @type {number}
   */
  let currentIndex = 0;

  /**
   *
   * @param {{name: string, data: number}} event
   */
  return (event) => {
    const time = event.data;

    if (isBelongTo(time, items[currentIndex])) {
      return;
    }

    currentIndex = isBelongTo(time, items[currentIndex + 1])
      ? currentIndex + 1
      : binarySearch(items, time, compareTimeToSRTItem);

    const text = items[currentIndex]?.text ?? "";
    emit(text);
  };
}

/**
 * @param {number} time
 * @param {SRTItem} item
 * @return {boolean}
 */
function isBelongTo(time, item) {
  return Boolean(item) && compareTimeToSRTItem(time, item) === 0;
}

/**
 * Compares time to srtItem time-span
 * @param {number} time
 * @param {SRTItem} srtItem
 * @return {-1 | 0 | 1}
 */
function compareTimeToSRTItem(time, srtItem) {
  const { startTime, endTime } = srtItem;

  if (time >= endTime) {
    return 1;
  }

  if (time < startTime) {
    return -1;
  }

  return 0;
}
